(function () {

    angular
        .module('smartertoolsApp')
        .controller('accountPreferencesController', ['$scope', '$log', '$timeout', 'accountService', 'notificationFactory', 'authenticationService', accountPreferencesController]);

    function accountPreferencesController($scope, $log, $timeout, accountService, notify, authenticationService) {
        const vm = this;
        vm.details = null;
        vm.isSaving = false;
        vm.emailAddress = authenticationService.getLoggedInEmail();

        // Functions
        vm.Reload = Reload;
        vm.SaveInfo = SaveInfo;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.Reload();
        }

        function Reload() {
            $scope.accountCtrl.isLoading++;
            accountService.getAccountSettings()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.details = data.Details;
                    vm.isPrimaryAccountHolder = data.IsPrimaryAccountHolder;
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => { $scope.accountCtrl.isLoading--; });
        }

        function SaveInfo() {
            vm.isSaving = true;
            accountService.saveEmailPreferences(vm.details)
                .then(() => {
                    vm.isSaving = false;
                    notify.success('Your information was updated.');
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating your information.');
                });
        }
    }

})();